import { Component, OnInit, OnDestroy } from '@angular/core';
import { InventoryService } from '@app/services/inventory/inventory.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { Store } from '@ngrx/store';
import * as CountsActions from '@app/modules/counts/store/actions/counts.actions';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { InventoryDialogComponent } from '../inventory-dialog/inventory-dialog.component';
import { SubSink } from 'subsink';
import { selectCountsCurrentIdState, selectCountsState } from '../store/selectors/counts.selectors';
import { first, take } from 'rxjs';
import { QuickBooksService } from '@app/modules/quick-books/services/quick-books.service';
import { ConfirmUpdateComponent } from '@app/shared/components/confirm-update/confirm-update.component';
import { selectIntegrationsQuickBooksState } from '@app/modules/integrations/store/selectors/integrations.selectors';
import { LimitAccessService } from '@app/core/services/limit-access.service';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { ModalExcelReportComponent } from '@app/shared/components/modal-excel-report/modal-excel-report.component';

@Component({
  selector: 'app-select-report',
  templateUrl: './select-report.component.html',
  styleUrls: ['./select-report.component.scss']
})
export class SelectReportComponent implements OnInit, OnDestroy {
  public options$: Subscription;
  public isInvoiceShowing: Boolean = false;
  public subs$ = new SubSink;
  public isQuickBooksLoading$: Boolean = false;
  public ID$: Number = 0;
  public hasQuickBooks$: Boolean = false;
  public countOption: Boolean = false;
  public valueOption: Boolean = false;
  public ReorderOption: Boolean = false;
  public ByCategoryOption: Boolean = false;
  public ByProducStorageOption: Boolean = false;
  public PrintCountSheetOption: Boolean = false;
  public Excel: Boolean = false;
  public inventoryType: any;

  constructor(
    private _inventory: InventoryService,
    private _matDialogRef: MatDialogRef<InventoryDialogComponent>,
    private _store: Store,
    public _quickBooks: QuickBooksService,
    private _matDialog: MatDialog,
    private limitAccessService: LimitAccessService,
    private route: ActivatedRoute,
    private location: Location,
  ) { }

  ngOnInit(): void {
    const currentUrlPath = this.location.path();

    if (currentUrlPath == "/counts/basic") {
      this.inventoryType = "basic";
    } else if (currentUrlPath == "/counts") {
      this.inventoryType = "counts";
    } else if (currentUrlPath == "/counts/finalized") {
      this.inventoryType = "finalized";
    } else {
      this.inventoryType = "basic";
    }

    this.limitAccessService.arraySettingAccess$.subscribe((arraySettingAccess) => {
      if (arraySettingAccess) {
        let resultCount = this.limitAccessService.getAccess('counts', this.inventoryType, 'reports', 'count');
        let resultValue = this.limitAccessService.getAccess('counts', this.inventoryType, 'reports', 'value');
        let resultReorder = this.limitAccessService.getAccess('counts', this.inventoryType, 'reports', 'reorder');
        let resultByCategory = this.limitAccessService.getAccess('counts', this.inventoryType, 'reports', 'by_category');
        let resultByProductStorage = this.limitAccessService.getAccess('counts', this.inventoryType, 'reports', 'by_product_storage')
        let resultPrintCountSheet = this.limitAccessService.getAccess('counts', this.inventoryType, 'reports', 'print_count_sheet');
        let resultExcel = this.limitAccessService.getAccess('counts', this.inventoryType, 'reports', 'excel');

        this.countOption = resultCount;
        this.valueOption = resultValue;
        this.ReorderOption = resultReorder;
        this.ByCategoryOption = resultByCategory;
        this.ByProducStorageOption = resultByProductStorage;
        this.PrintCountSheetOption = resultPrintCountSheet;
        this.Excel = resultExcel;
      }
    });
    this.subs$.add(this._store.select(selectCountsCurrentIdState).subscribe(id => this.ID$ = id));
    this.subs$.add(this._store.select(selectIntegrationsQuickBooksState).subscribe(hasQuickBooks => this.hasQuickBooks$ = hasQuickBooks));
  }

  ngOnDestroy() {

  }

  onSetReport(currentType) {
    // All reports use same width for consistency
    if (currentType !== 'excel') {
      this._matDialogRef.updateSize('75vw', '');
    }

    this._store.dispatch(CountsActions.setCurrentType({ currentType }));
  }

  /*onGenerateExcel(){
    this._store.select(selectCountsCurrentIdState).pipe(first()).subscribe((res) => {
      this._inventory.onGetExcel(res).pipe(first()).subscribe((data:any)=> {
        const headers = ["SKU", "Product Description", "Barcode", "Brand", "UOM", "MSL1", "MSL2", "Category", "Area", "Cost Price", "Retail Price", "Count Type",
        "Count Type Quantity", "Custom Product Field", "Custom Product Field2", "Count", "Total Cost", "Total Retail", "Total Avail"];
        this._inventory.onExcelCount(headers, data.inv, data.invItems);
      });
    });
  }*/

  onGenerateExcel() {
    this._store.select(selectCountsCurrentIdState).pipe(first()).subscribe((res) => {
      this._inventory.onGetExcel(res).pipe(first()).subscribe((data: any) => {
        const headers = ["SKU", "Product Description", "Product Storage", "Brand", "UOM", "MSL1", "MSL2", "Category", "Product Storage", "Cost Price", "Retail Price", "Count Type",
          "Count Type Quantity", "Custom Product Field", "Custom Product Field2", "Count", "Total Cost", "Total Retail", "Total Avail"];
        const dialogRef = this._matDialog.open(ModalExcelReportComponent, {
          minWidth:'30vw',
          height: '350px',
          maxWidth: '700px',
          data: { headers: headers, inv: data.inv, invItems: data.invItems }
        });

        dialogRef.afterClosed().pipe(first()).subscribe(res => {
          if(res!=null && res.email!=null && res.email!=''){

           const request_data = {
             email: res.email,
             id: data.inv.invID,
             finalized: this._inventory.isFinalizeScreen() ? 1 : 0,
             min_qty_option: 1,
             type: 'byExcel'
           }
   
             this._inventory.onSendReportPDF(request_data);
           }
       });

        

      });
    });
  }



}
